import { Minus, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function QuantityStepper({
  value,
  min = 0,
  max,
  onChange,
  label,
}: {
  value: number
  min?: number
  max?: number
  onChange: (value: number) => void
  label: string
}) {
  return (
    <div className="flex items-center gap-2" aria-label={`${label} quantity`}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 w-8 px-0"
        disabled={value <= min}
        onClick={() => onChange(value - 1)}
        aria-label={`Remove ${label} ticket`}
      >
        <Minus className="h-3.5 w-3.5" />
      </Button>
      <span className="w-5 text-center text-body-sm tabular-nums">{value}</span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 w-8 px-0"
        disabled={max !== undefined && value >= max}
        onClick={() => onChange(value + 1)}
        aria-label={`Add ${label} ticket`}
      >
        <Plus className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
